"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var Card_1 = require("../Card");
var Swiper_1 = require("@devsisters/ui-common/lib/Swiper");
var icons_1 = require("../icons");
var styles = require("./index.module.css");
var Testimonials = function (_a) {
    var _b;
    var className = _a.className, style = _a.style, _c = _a.type, type = _c === void 0 ? 'pc' : _c, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, testimonials = _a.testimonials;
    return (React.createElement(Card_1.default, { className: classnames_1.default(styles.testimonials, (_b = {},
            _b[styles.pc] = type === 'pc',
            _b[styles.mobile] = type === 'mobile',
            _b), className), style: style, shadow: type === 'pc' ? 'big' : 'small' },
        React.createElement(Swiper_1.default, __assign({ ref: function (node) {
                // fucking safari
                if (!node)
                    return;
                node.swiper.update();
            }, containerClass: styles.swiper, slidesPerView: "auto", speed: 500, pagination: {
                el: ".swiper-pagination." + styles.pagination,
                type: 'fraction',
            } }, (type === 'pc' ? navigationProps : null), parallaxEffectProps, { loop: true, autoplay: !!autoplay && { delay: typeof autoplay === 'number' ? autoplay : 5000 }, allowTouchMove: type === 'mobile' }), testimonials.map(function (testimonial, i) { return (React.createElement("div", { key: i, className: styles.slide },
            React.createElement("blockquote", __assign({}, mainParallaxAttributes),
                React.createElement("span", { className: testimonial.who && styles.quote }, testimonial.quote)),
            testimonial.who && (React.createElement("div", __assign({ className: styles.who }, subParallaxAttributes), testimonial.who)))); }))));
};
// const fadeEffectProps: Pick<SwiperProps, 'effect' | 'fadeEffect'> = {
//   effect: 'fade',
//   fadeEffect: { crossFade: true },
// };
var parallaxEffectProps = {
    parallax: true,
};
var mainParallaxAttributes = {
    'data-swiper-parallax': '30%',
    'data-swiper-parallax-opacity': '0',
};
var subParallaxAttributes = {
    'data-swiper-parallax': '0%',
    'data-swiper-parallax-opacity': '0',
};
var navigationProps = {
    navigation: {
        nextEl: '.swiper-button-next' + ("." + styles.nextButton),
        prevEl: '.swiper-button-prev' + ("." + styles.prevButton),
    },
    renderNextButton: function () { return (React.createElement("div", { className: classnames_1.default('swiper-button-next', styles.nextButton) },
        React.createElement(icons_1.NextIcon, null))); },
    renderPrevButton: function () { return (React.createElement("div", { className: classnames_1.default('swiper-button-prev', styles.prevButton) },
        React.createElement(icons_1.PrevIcon, null))); },
};
exports.default = Testimonials;
